<script lang="ts">
  import { get,  writable } from "svelte/store";
  import ContactDropdown from "../../components/Business/ContactDropdown.svelte";
  import SearchHeader from "../../components/SearchHeader.svelte";
  import Input from "../../components/Form/Fields/Input.svelte";
  import DateInput from "../../components/Form/Fields/DateInput.svelte";
  import Switch from "../../components/Form/Fields/Switch.svelte";
  import NumberInput from "../../components/Form/Fields/NumberInput.svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import InvoiceDashboard from "../../components/Business/InvoiceDashboard.svelte";
  import Table from "../../components/Table/Table.svelte";
  import type { ICompanyInvoice, ICompanyInvoiceRow } from "../../entities";
  import type { ICompanyInvoiceDTO, ICompanyInvoiceEmailDTO } from "../../services/DTO";
  import CustomFields from "../../components/CustomFields/CustomFields.svelte";
  import FormLayout from "../../layout/FormLayout.svelte";
  import type { IApiResponse } from "../../utils/api/api-response";
  import { companyInvoiceDtoFields } from "../../utils/TableFields/company-invoice-dto.fields";
  import { companyInvoiceRowsDtoFields } from "../../utils/TableFields/company-invoice-row-dto.fields";
  import OwnershipDropdown from "../../components/Form/Fields/Dropdown/OwnershipDropdown.svelte";
  import {setNull} from "../../utils/object-utils";
  import { PermissionService } from "../../utils/misc/permission-utils";
  import InvoiceEmailListEditor from "../../components/Business/InvoiceEmailListEditor.svelte";

    import { user } from "../../app.store";
  import {
    companyInvoicesDashboard,
    companyInvoices,
    pagination_invoices,
    onPageChangeInvoice,
    filter_invoice,
    searchInvoices,
    companyInvoice,
    loadInvoices,
    loadInvoicesDashboard,
    newInvoice,
    onDeleteInvoice,
    saveInvoice,
    exportInvoicePdf,
    createNewInvoice,
    sendEmail
  } from "./company.store";
  import { initializeCustomFields } from "../../utils/CustomFieldEntities/custom-field-utils";


    let canedit_comp : boolean = PermissionService.isAllowedTo($user, 'companies.canedit');
    let candelete: boolean = PermissionService.isAllowedTo($user, 'companyinvoices.canedit');
    let cancreate: boolean = PermissionService.isAllowedTo($user, 'companyinvoices.cancreate');
    let canedit : boolean = PermissionService.isAllowedTo($user, 'companyinvoices.canedit');
    let cansend : boolean = PermissionService.isAllowedTo($user, 'companyinvoices.cansend');

    if (canedit == null)
      canedit = canedit;

  const editing = writable<boolean>(false);
    export let oid: number;

    let issupplier = window.location.pathname.indexOf("supplier") >= 0;

  $: isNew = $companyInvoice != null && $companyInvoice.oid == 0;
  $: canSubmitExisting =
    $companyInvoice != null &&
    $companyInvoice.companyId != 0 &&
    $companyInvoice.ownershipId != 0;
  $: canSubmitNew = $newInvoice != null && $newInvoice.ownershipId != "" && $newInvoice.numeroFattura != "" && $newInvoice.importo != null && $newInvoice.dataEmissione != null;

  let companyInvoiceRow = null;
  $: isNewRow = companyInvoiceRow != null && companyInvoiceRow.oid <= 0;
  $: canSubmitNewRow = companyInvoiceRow != null && companyInvoiceRow.codiceProdotto != "" && companyInvoiceRow.importo != null;
  $: canSubmitExistingRow = companyInvoiceRow != null && companyInvoiceRow.codiceProdotto != "" && companyInvoiceRow.importo != null;

  async function onSubmitExisting() {
    let _record = get(companyInvoice);
    let _resp: IApiResponse<ICompanyInvoiceDTO> = await saveInvoice(_record);
    onCancel();
    loadInvoices(_resp.payload.invoice.companyId);
    loadInvoicesDashboard(_resp.payload.invoice.companyId);
  }

  async function onSubmitNew() {
    let _record = get(newInvoice);
    let _resp: IApiResponse<ICompanyInvoiceDTO> = await saveInvoice(_record);
    onCancel();
    loadInvoices(_resp.payload.invoice.companyId);
    loadInvoicesDashboard(_resp.payload.invoice.companyId);
  }

  function onCancel() {
    editing.set(false);
    companyInvoice.set({} as ICompanyInvoiceDTO);
  }

  function onSendemail(item: ICompanyInvoiceDTO) {
    sendEmail(item.oid, item.invoice.companyId);
    resetSearchInvoices();
  }

  function onSendEmail(){
    sendEmail();
    editing.set(false);
    companyInvoice.set({} as ICompanyInvoiceDTO);
  }

  function onSubmitExistingRow(){
    let _record = get(companyInvoice);
    if (companyInvoiceRow.oid == 0)
    {
        companyInvoiceRow.oid = -Date.now();
        _record.invoiceRows.push(companyInvoiceRow);
    }

    companyInvoiceRow = null;
    companyInvoice.set(_record);
  }

  function onCancelRow() {
    companyInvoiceRow = null;
  }


  function onCreate() {
    let item = {
      oid: 0,
      invoice: {
        oid : 0,
        companyId: oid
      } as ICompanyInvoice,
      invoiceRows: []
    } as ICompanyInvoiceDTO;

    onEdit(item);
  }

  function onEdit(item: ICompanyInvoiceDTO) {
    companyInvoice.set(Object.assign({}, item));
    editing.set(true);
  }

  function onDownload(item: ICompanyInvoiceDTO) {
    if (item.invoice.urlPdf != null && item.invoice.urlPdf != "")
      exportInvoicePdf(item.oid);
  }

  function resetSearchInvoices(){
    setNull($filter_invoice.criteria);
    searchInvoices(oid);
  }

  function onCreateRow(){
    companyInvoiceRow = {
      oid: 0, companyInvoiceId: $companyInvoice.oid
    } as ICompanyInvoiceRow;
  }
  function onEditRow(r:ICompanyInvoiceRow){
    companyInvoiceRow = r;
  }
  function onDeleteRow(r : ICompanyInvoiceRow){
    let _record = get(companyInvoice);
    for(let i=0;i<  _record.invoiceRows.length;i++)
    {
      if (_record.invoiceRows[i].oid == r.oid)
      {
        _record.invoiceRows.splice(i,1);
        break;
      }
    }

    companyInvoiceRow = null;
    companyInvoice.set(_record);
  }

</script>

{#if $editing === false}

  <InvoiceDashboard
    entityId={oid}
    records={$companyInvoicesDashboard}
    bind:searchValueOwnershipId={$filter_invoice.criteria.ownershipid}
    bind:searchValueImportoPagato={$filter_invoice.criteria.importoPagato}
    bind:searchValueDataScadenzaFrom={$filter_invoice.criteria.dataScadenzaFrom}
    bind:searchValueDataScadenzaTo={$filter_invoice.criteria.dataScadenzaTo}
    on:search={() => searchInvoices(oid)}
    />
    <br/>
    <SearchHeader
      entitySingular="fattura"
      entityPlural="fatture"
      numRecords={$pagination_invoices != null ? $pagination_invoices.totalRecords : 0}
      bind:searchValue={$filter_invoice.criteria.query}
      on:search={() => searchInvoices(oid)}
      on:reset={() => resetSearchInvoices()}
      clearButtonVisible={true}
    />

  <Table
    loading={false}
    fields={companyInvoiceDtoFields.filter(f=>(!issupplier || f.name != 'urlPdf'))}
    records={$companyInvoices}
    pagination={$pagination_invoices}
    createEnabled={cancreate}
    showEnabled={true}
    deleteEnabled={candelete}
    downloadEnabled={true}
    customEnabled={cansend}
    customIcon="send"
    on:custom={(e) => onSendemail(e.detail)}
    on:create={(_) => onCreate()}
    on:show={(e) => onEdit(e.detail)}
    on:download={(e) => onDownload(e.detail)}
    on:delete={(e) => onDeleteInvoice(e.detail)}
    on:pageChange={(e) => onPageChangeInvoice(oid, e.detail)}
  />
{:else if $companyInvoice}
  <div class="columns">
    <div class="column is-9">
    <FormLayout
      submitEnabled={cancreate && isNew || canedit}
      canSubmit={canSubmitExisting}
      {isNew}
      createButtonText="Crea"
      on:submit={onSubmitExisting}
      on:cancel={onCancel}
    >
      <div class="columns">
        <div class="column is-4">
          <FormField>
            <OwnershipDropdown
              name="Azienda proprietaria"
              required={true}
              disabled={!(cancreate && isNew || canedit)}
              bind:value={$companyInvoice.invoice.ownershipId}
            />
          </FormField>
        </div>
        <div class="column is-4">
          <FormField>
            <Input
              name="Numero fattura"
              required={true}
              disabled={!(cancreate && isNew || canedit)}
              bind:value={$companyInvoice.invoice.numeroFattura}
            />
          </FormField>
        </div>
        <div class="column is-4">
          <FormField>
            <NumberInput
              name="Importo"
              required={true}
              disabled={!(cancreate && isNew || canedit)}
              bind:value={$companyInvoice.invoice.importo}
            />
          </FormField>
        </div>
      </div>
      <div class="columns">
        <div class="column is-3">
          <FormField>
            <DateInput
              name="Data emissione"
              required={true}
              disabled={!(cancreate && isNew || canedit)}
              bind:value={$companyInvoice.invoice.dataEmissione}
            />
          </FormField>
        </div>

        <div class="column is-3">
          <FormField>
            <DateInput
              name="Data scadenza"
              required={true}
              disabled={!(cancreate && isNew || canedit)}
              bind:value={$companyInvoice.invoice.dataScadenza}
            />
          </FormField>
        </div>


        <div class="column is-3">
          <FormField>
            <DateInput
              name="Data pagamento"
              required={false}
              disabled={!(cancreate && isNew || canedit)}
              bind:value={$companyInvoice.invoice.dataPagamento}
            />
          </FormField>
        </div>

        <div class="column is-3">
          <FormField>
            <Switch
              name="Saldata"
              required={false}
              disabled={!(cancreate && isNew || canedit)}
              bind:value={$companyInvoice.invoice.importoPagato}
            />
          </FormField>
        </div>
      </div>
      <div class="columns">
        <div class="column is-12">
          <FormField>
            <Input
              name="Url PDF"
              required={false}
              disabled={!(cancreate && isNew || canedit)}
              bind:value={$companyInvoice.invoice.urlPdf}
            />
          </FormField>
        </div>
      </div>
      <div class="column is-12">
      {#if companyInvoiceRow == null}
      <Table
        loading={false}
        fields={companyInvoiceRowsDtoFields}
        records={$companyInvoice.invoiceRows}
        pagination={null}
        createEnabled={canedit}
        editEnabled={canedit}
        deleteEnabled={canedit}
        on:create={(_) => onCreateRow()}
        on:edit={(e) => onEditRow(e.detail)}
        on:delete={(e) => onDeleteRow(e.detail)}
      />
      {:else}
      <FormLayout
        submitEnabled={true}
        canSubmit={canSubmitExistingRow}
        {isNewRow}
        createButtonText="Applica"
        submitButtonText="Applica"
        on:submit={onSubmitExistingRow}
        on:cancel={onCancelRow}
      >
        <div class="columns">
          <div class="column is-12">
            <FormField>
              <Input
                name="Codice prodotto"
                required={true}
                bind:value={companyInvoiceRow.codiceProdotto}
              />
            </FormField>
            <FormField>
              <Input
                name="Descrizione prodotto"
                required={true}
                bind:value={companyInvoiceRow.descrizione}
              />
            </FormField>
            <FormField>
              <NumberInput
                name="Importo"
                required={true}
                bind:value={companyInvoiceRow.importo}
              />
            </FormField>
          </div>
        </div>
      </FormLayout>
      {/if}
      </div>
    </FormLayout>
    </div>
    <div class="column is-3">
      <!--
      <div class="box">
        <h1 class="subtitle">Riepilogo</h1>

      </div>
      -->
      {#if cansend }
      <InvoiceEmailListEditor
        entityId={$companyInvoice.oid}
        emails={$companyInvoice.invoiceEmails}
        disabled={false}
        on:save={onSendEmail}
      />
      {/if}
    </div>
  </div>
{/if}

<style>
  .add-contact-type {
    margin: auto;
    margin-bottom: 2rem;
  }
  .add-contact-type .control .radio {
    margin-left: 2rem;
    margin-right: 2rem;
  }
</style>
